/**
 * Initialise Tako breadcrumbs
 */

/* -----------------------------------------------------------------------------
 * Tako Breadcrumbs
 * -------------------------------------------------------------------------- */
import { getLogger } from './utils/logger-context';
import { resolveComponentScope } from './utils/resolveComponentScope';

const COMPONENT_NAME = 'Breadcrumbs';

export const init = (unresolvedScope: string | HTMLElement | unknown) => {
    const logger = getLogger();
    const scope = resolveComponentScope(unresolvedScope);
    const defaultLoggerArgs = {
        componentName: COMPONENT_NAME,
        scope,
    };
    logger.debug(`Initialising ${COMPONENT_NAME} component.`, { scope });

    const allTakoBreadcrumbs =
        scope.querySelectorAll<HTMLElement>('.tako-breadcrumbs');
    allTakoBreadcrumbs.forEach((takoBreadcrumbs) => {
        try {
            const truncatedBreadcrumbs = takoBreadcrumbs.querySelectorAll(
                '.tako-breadcrumbs--truncated',
            );

            truncatedBreadcrumbs.forEach((truncatedBreadcrumb) => {
                const breadcrumbLink = truncatedBreadcrumb.querySelector('a');
                if (breadcrumbLink) {
                    breadcrumbLink.setAttribute(
                        'data-tooltip-content',
                        breadcrumbLink.textContent || '',
                    );
                    breadcrumbLink.setAttribute('data-placement', 'top');
                }
            });
        } catch (error) {
            logger.error(error as string, {
                ...defaultLoggerArgs,
                element: takoBreadcrumbs,
            });
        }
    });
};
